import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import appConifg from "../../config/default.json";
import Chip from "@material-ui/core/Chip";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import MUIDataTable from "mui-datatables";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ViewHeadlineIcon from "@material-ui/icons/ViewHeadline";
import { makeStyles } from "@material-ui/core/styles";
import {
  CircularProgress,
  Typography,
  StepIcon,
  IconButton,
  Grid,
  Tooltip,
} from "@material-ui/core";
import RefreshRoundedIcon from "@material-ui/icons/RefreshRounded";
import {
  addressingApiResponseMapper,
  addressIssuesMapper,
  acmApiPaginatedResponseMapper,
} from "../mappers/addressingMappers";
import { getAddressIssuesPaginated } from "../../serviceClients/addressingClient";
import toast, { Toaster } from "react-hot-toast";
import Link from "@material-ui/core/Link";
import {
  ZoomToLatLng,
  DisplayAddressIssuePointOnMap,
} from "../map/AddressingMapView";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles((theme) => ({
  iconButton: {},
  iconContainer: {
    marginRight: "24px",
  },
}));

const initialstate = {
  refresh: false,
  isLoading: false,
  page: 0,
  pagination: true,
  count: 999,
  //  pageSize: 3,
  rowsPerPage: 5,
  sortOrder: { name: "reportedDate", direction: "desc" },
  // fitler: '',
  data: [["Loading Data..."]],
  IssueStauses: [],
  IssueTypes: [],
};

const ISSUE_STATUS_OPEN_ID = appConifg.IssueInbox.OpenIssueTypeId; //HARDCODE database value
const ISSUE_STATUS_CLOSED_ID = appConifg.IssueInbox.ClosedIssueTypeId;

function IssueInboxGrid(props) {
  const classes = useStyles();
  const { t, i18n } = useTranslation("issueInboxPage");

  // const AdddressIssueTypesHashMap = props.addressIssueTypes.data.reduce((map,obj)=>{
  //     map[obj.id] = obj.name;
  //     return map
  // },{})

  // const AddressStatusTypesHashMap = props.addressIssueStatus.data.reduce((map,obj)=>{
  //     map[obj.id] = obj.name;
  //     return map
  // },{})

  const [AdddressIssueTypesHashMap, setAdddressIssueTypesHashMap] = useState(
    {}
  );
  const [AddressStatusTypesHashMap, setAddressStatusTypesHashMap] = useState(
    {}
  );

  useEffect(() => {
    if (props.addressIssueTypes.loading || props.addressIssueStatus.loading) {
      return;
    }
    //HashMap for IsssueTypes
    const IHM = props.addressIssueTypes.data.reduce((map, obj) => {
      map[obj.id] = obj.name;
      return map;
    }, {});
    //HashMaps for Issue Status
    const SHM = props.addressIssueStatus.data.reduce((map, obj) => {
      map[obj.id] = obj.name;
      return map;
    }, {});

    setAdddressIssueTypesHashMap(IHM);
    setAddressStatusTypesHashMap(SHM);
    setState({ ...state, IssueStauses: [SHM[ISSUE_STATUS_OPEN_ID]] });
    //  setState({...state, IssueTypes: [Object.values(IHM)]})
  }, [props.addressIssueTypes, props.addressIssueStatus]);

  const [state, setState] = useState(initialstate);

  const [activeFilterChip, setActiveFilterChip] = useState(1);
  const ChipIssueStatusFilter = () => {
    return (
      <>
        <Chip
          label={t("AllIssues")}
          color={activeFilterChip == -1 ? "primary" : "default"}
          onClick={() => {
            setActiveFilterChip(-1);
            setState({ ...state, IssueStauses: [] });
          }}
        />
        <Chip
          label={t("openedIssues")}
          color={activeFilterChip == 1 ? "primary" : "default"}
          onClick={() => {
            setActiveFilterChip(1);
            setState({
              ...state,
              IssueStauses: [AddressStatusTypesHashMap[ISSUE_STATUS_OPEN_ID]],
            });
          }}
        />
        <Chip
          label={t("ClosedIssues")}
          color={activeFilterChip == 3 ? "primary" : "default"}
          onClick={() => {
            setActiveFilterChip(3);
            setState({
              ...state,
              IssueStauses: [AddressStatusTypesHashMap[ISSUE_STATUS_CLOSED_ID]],
            });
          }}
        />
      </>
    );
  };

  //hook to load Values from the server
  useEffect(() => {
    if (
      Object.keys(AdddressIssueTypesHashMap).length == 0 ||
      Object.keys(AddressStatusTypesHashMap).length == 0
    ) {
      return;
    }
    let mounted = true;
    mounted && setState({ ...state, isLoading: true, data: [] });
    const [promise, source] = getAddressIssuesPaginated(
      { ...state },
      props.appSettings.userCredentials.token.access_token
    );
    promise
      .then((aresp) => {
        const {
          isSuccess,
          isPartial,
          message,
          respData,
          pageNo,
          pageSize,
          totalCount,
          successObj,
          failedObj,
        } = acmApiPaginatedResponseMapper(aresp.data);
        if (isSuccess) {
          var issuesData = addressIssuesMapper(respData);
          mounted &&
            setState({
              ...state,
              count: totalCount,
              pageNo: pageNo - 1,
              data: issuesData,
              isLoading: false,
            });
        } else {
          mounted && setState({ ...state, loading: false });
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .then();

    return () => {
      mounted = false;
    };
  }, [
    state.page,
    state.rowsPerPage,
    state.sortOrder,
    state.filter,
    props.refreshGridValue,
    state.IssueStauses,
    state.IssueTypes,
  ]);

  const refreshGridData = () => {
    props.refreshGrid();
  };

  //define the coloun name here so in the same order which are defined in grid_columns
  const grid_columns_names = [
    "id",
    "fk_Issue_TypeId",
    "fK_Issue_StatusId",
    "reportedDate",
    "reportUserName",
    "reporterDescription",
    "email",
    "mobile",
    "longitude",
    "latitude",
    "searchText",
    "responderUserName",
    "responderComments",
    "respondedDate",
    "todisplay", //here is the acutal rendered content with customBody
    "action",
  ];

  const getGridRowDataArrayToObj = (row_data) => {
    const row_data_json = {};
    row_data.forEach((item, index) => {
      row_data_json[grid_columns_names[index]] = item;
    });
    return row_data_json;
  };

  const grid_columns = [
    {
      name: "id",
      label: "Ref",
      options: { filter: false, searchable: false },
    },
    {
      name: "fK_Issue_TypeId",
      label: "Issue Type", //Issue Types
      options: {
        filter: true,
        searchable: false,
        display: "excluded",
        filterOptions: {
          //   renderValue:(value)=>{ return AdddressIssueTypesHashMap[value]   }
          names: Object.values(AdddressIssueTypesHashMap),
        },
        // customFilterListOptions : {
        //     render : (value)=>{ return AdddressIssueTypesHashMap[value]   }
        // }
      },
    },
    {
      name: "fK_Issue_StatusId",
      label: "Issues Status", //Issue Status
      options: {
        filter: false,
        searchable: false,
        display: "excluded",
      },
    },
    {
      name: "reportedDate",
      label: "ReportedDate",
      options: {
        filter: false,
        searchable: false,
        display: "excluded",
        customBodyRender: (value, tableMeta, updatedValue) => {
          if (!value) return;
          const row_data = tableMeta.rowData;
          const row_data_json = getGridRowDataArrayToObj(row_data);
          //return AdddressIssueTypesHashMap[value]
          return AdddressIssueTypesHashMap[row_data_json.fk_Issue_TypeId];
        },
      },
    },
    {
      name: "reportUserName",
      label: "reportUserName",
      options: { filter: false, searchable: false, display: "excluded" },
    },
    {
      name: "reporterDescription",
      label: "reporterDescription",
      options: { display: "excluded", filter: false, searchable: false },
    },
    {
      name: "email",
      label: "email",
      options: { display: "excluded", filter: false, searchable: false },
    },
    {
      name: "mobile",
      label: "mobile",
      options: { display: "excluded", filter: false, searchable: false },
    },
    {
      name: "longitude",
      label: "longitude",
      options: { display: "excluded", filter: false, searchable: false },
    },
    {
      name: "latitude",
      label: "latitude",
      options: { display: "excluded", filter: false, searchable: false },
    },
    {
      name: "searchText",
      label: "searchText",
      options: { display: "excluded", filter: false, searchable: false },
    },
    {
      name: "responderUserName",
      label: "responderUserName",
      options: { display: "excluded", filter: false, searchable: false },
    },
    {
      name: "responderComments",
      label: "responderComments",
      options: { display: "excluded", filter: false, searchable: false },
    },
    {
      name: "respondedDate",
      label: "respondedDate",
      options: { display: "excluded", filter: false, searchable: false },
    },
    {
      name: "fK_Issue_TypeId",
      label: "Issues List ", //here is wher to render as custom to display necessary info,
      options: {
        filter: false,
        searchable: false,
        customBodyRender: (value, tableMeta, updatedVaule) => {
          if (!value) return;
          const row_data = tableMeta.rowData;
          const row_data_json = getGridRowDataArrayToObj(row_data);
          // return AdddressIssueTypesHashMap[row_data_json.fk_Issue_TypeId] + " ("+ row_data_json.reportedDate +")"
          return (
            <Link
              component="button"
              onClick={() => {
                //  alert("Will Zoom To the location" +  row_data_json.longitude +","+ row_data_json.latitude)
                // ZoomToLatLng(row_data_json.latitude,row_data_json.longitude)
                DisplayAddressIssuePointOnMap(
                  row_data_json.latitude,
                  row_data_json.longitude
                );
              }}
            >
              {AdddressIssueTypesHashMap[row_data_json.fk_Issue_TypeId] +
                " (" +
                row_data_json.reportedDate +
                ")"}
            </Link>
          );
        },
      },
    },
    {
      name: "", //this is for action
      options: {
        filter: false,
        sort: false,
        display: true,
        customBodyRender: (value, tableMeta, updatedVaule) => {
          const row_data = tableMeta.rowData;
          const row_data_json = getGridRowDataArrayToObj(row_data);
          const issueStatus = row_data_json.fK_Issue_StatusId;
          if (issueStatus == ISSUE_STATUS_OPEN_ID) {
            return (
              <IconButton
                size="small"
                onClick={() => {
                  props.showIssueDetails(row_data_json);
                }}
              >
                <Tooltip title="View Details and Send Response">
                  <ViewHeadlineIcon />
                </Tooltip>
              </IconButton>
            );
          } else {
            return (
              <IconButton
                size="small"
                onClick={() => {
                  const row_data_json = getGridRowDataArrayToObj(row_data);
                  props.showIssueDetails(row_data_json);
                }}
              >
                <Tooltip title="View Details">
                  <PlaylistAddCheckIcon />
                </Tooltip>
              </IconButton>
            );
          }
          // return(

          //     <IconButton size="small" onClick={()=>{
          //         const row_data = tableMeta.rowData
          //         const row_data_json = getGridRowDataArrayToObj(row_data)
          //         props.showIssueDetails(row_data_json)
          //     }}>
          //         <VisibilityIcon />
          //     </IconButton>
          // )
        },
      },
    },
  ];

  const localization_options = {
    textLabels: {
      body: {
        noMatch: "No Issue To display",
      },
    },
  };

  const grid_options = {
    //tableBodyHeight : "50%",
    rowsPerPageOptions: [],
    serverSide: true,
    count: state.count,
    rowPerPage: state.pageSize,
    pagination: true,
    sort: true,
    sortOrder: state.sortOrder, //as of now only 1 column
    viewColumns: false,
    jumpToPage: false,
    print: false,
    download: false,
    selectableRows: "none", //"multiple", "single", "none".
    filter: true,
    // filterType: "checkbox",
    responsive: "standard",
    search: false,
    customToolbar: () => (
      //Add Refresh Button here -- For now only 1 button
      <div style={{ display: "flex" }}>
        <ChipIssueStatusFilter />
        <Tooltip title={"Refresh"}>
          <IconButton
            className={classes.iconButton}
            onClick={() => {
              refreshGridData();
            }}
          >
            <RefreshRoundedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </div>
    ),
    onTableChange: (action, tableState) => {
      console.log("action is ", action);
      switch (action) {
        case "changePage":
          setState({ ...state, page: tableState.page });
          break;
        case "changeRowsPerPage":
          setState({ ...state, rowsPerPage: tableState.rowsPerPage });
          break;
        case "sort":
          //var sortString = tableState.sortOrder.name + ' ' + tableState.sortOrder.direction
          setState({ ...state, sortOrder: tableState.sortOrder });
        case "filterChange":
          setState({ ...state, IssueTypes: tableState.filterList[1] }); //hardcoding array position for now to filter Issue Types
          break;
        default:
          break;
      }
    },

    textLabels: {
      body: {
        noMatch: t("noMatch"),
      },
      filter: {
        all: t("all"),
        title: t("title"),
        reset: t("reset"),
      },
      pagination: {
        next: t("next"),
        previous: t("previous"),
        rowsPerPage: t("rowsPerPage"),
        displayRows: t("displayRows"),
      },
    },
  };
  return (
    <Grid container>
      {/* <Grid item xs={12}>
                {JSON.stringify(AdddressIssueTypesHashMap)}
            </Grid> */}
      <Grid item xs={12}>
        {Object.keys(AddressStatusTypesHashMap).length > 0 ? (
          <MUIDataTable
            data={state.data}
            columns={grid_columns}
            options={grid_options}
          />
        ) : null}
      </Grid>
    </Grid>
  );
}

const mapStateToProps = (state) => {
  return {
    addressIssueTypes: state.addressIssueTypes,
    addressIssueStatus: state.addressIssueStatusTypes,
    appSettings: state.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

// const buildSortOrderForServerFromTable = (tableStateSortOrder)=>{
//     if(tableStateSortOrder.name){
//         return `${tableStateSortOrder.name} , ${direction}`
//     }else {
//         return null
//     }
// }

// const buildSortOrderObjectFromString = (str)=>{
//     if(!str || str.length < 1) return {}

//     var keyVal = str.split(" ")
//     return { name : keyVal[0] , direction : keyVal[1]}
// }

export default connect(mapStateToProps, mapDispatchToProps)(IssueInboxGrid);
